import differenceInCalendarDays from 'date-fns/differenceInCalendarDays'
import isNumber from 'lodash/isNumber'

import { Granularity } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { parseISODate } from './format'

export const getSuggestedGranularityForPeriod = (dateRangeSelected: string | number) => {
  const differenceInDays = isNumber(dateRangeSelected)
    ? dateRangeSelected
    : differenceInCalendarDays(new Date(), parseISODate(dateRangeSelected))

  switch (true) {
    case differenceInDays > 179:
      return Granularity.monthly
    case differenceInDays > 89:
      return Granularity.weekly
    case differenceInDays > 1:
      return Granularity.daily
    default:
      return undefined
  }
}
